import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';
import NodePartnerCard from '../../../../../implementations/Node/Partner/Card';
import type { SearchAllContentPartnerHit } from '../../../../SearchAllContent/types';

const MetaSearchPartnerHit: React.FC<{ hit: SearchAllContentPartnerHit }> = ({ hit }) => (
  <NodePartnerCard
    title={hit.page_title[0]}
    linkText={hit.link_text[0]}
    linkUrl={hit.link_url[0]}
    subtitle={hit.body_processed?.[0]}
    image={hit.image_ratio_1_1_xs?.[0] && (
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['16_9', '16_9', '16_9', '4_3', '4_3'],
          ['sm', 'sm', 'md', 'sm', 'sm'],
        )}
        alt={hit.image_alt?.[0]}
        lazyload={false}
      />
    )}
  />
);

export default MetaSearchPartnerHit;
